const TopicTwo = () => {
  return (
    <div className="quality-section-market">
      <div className="quality-header-market">
        <h1>How does Stock CFD Trading work?</h1>
        <p>
          Stock trading traditionally involves buying or selling a share of
          ownership in an individual company listed on a public exchange such as
          the ASX or NASDAQ, usually without leverage.
        </p>
      </div>
    </div>
  );
};

export default TopicTwo;
